import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function RefundReport(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [refundData, setRefundData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchData();
        const intervalId = setInterval(fetchData, 12000);
        return () => clearInterval(intervalId);
    }, [startDate, endDate]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
        axios.get(url)
            .then(response => {
                setRefundData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const rows = refundData.map((item) => {
        return {
            id: item.id,
            date_time: `${item.add_date_date} ${item.add_time}`,
            pat__pat_id: item.pat__pat_id,
            pat__patient: item.pat__patient,
            invoice: item.invoice,
            receipt: item.receipt,
            invoice_amount: item.invoice_amount,
            paid_amount: item.paid_amount,
            refund_amount: item.refund_amount,
            balance: item.balance,
            receivedby: item.receivedby,
            reason: item.reason,
            addedby: item.addedby,
        };
    });
    const columns = [
        {field: 'date_time', headerName: 'Date', width: 150},
        {field: 'pat__pat_id', headerName: 'Pat ID', width: 50},
        {field: 'pat__patient', headerName: 'Patient', width: 150},
        {field: 'invoice', headerName: 'Invoice', width: 110},
        {
            field: 'receipt', headerName: 'Refund Receipt',
            renderCell: (params) => (
                <Link to={`/refund-invoice-op/${params.row.receipt}`} target="_blank">
                    {params.row.receipt}
                </Link>
            ),
            width: 120
        },
        {field: 'invoice_amount', headerName: 'Invoiced Amount', width: 100},
        {field: 'paid_amount', headerName: 'Paid Amount', width: 100},
        {field: 'refund_amount', headerName: 'Refund Amount', width: 100},
        {field: 'balance', headerName: 'Balance', width: 100},
        {field: 'receivedby', headerName: 'Received By', width: 100},
        {field: 'reason', headerName: 'Reason', width: 100},
        {field: 'addedby', headerName: 'Updated By', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'invoice_amount');
        const totalPaidAmount = getTotal(rows, 'paid_amount');
        const totalBalance = getTotal(rows, 'balance');
        const totalRefundAmount = getTotal(rows, 'refund_amount');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '2px'}}>
                <div>Total</div>
                <div>{totalInvoicedAmount}</div>
                <div>{totalPaidAmount}</div>
                <div>{totalRefundAmount}</div>
                <div>{totalBalance}</div>
            </div>
        );
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> Refund Report</h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="user" className="form-label">Select Date</label>
                    <div className="date-filter-container">
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />

                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />
                    </div>

                </div>
            </div>

            {!isLoading && refundData.length > 0 ? (
                <div style={{height: '100%', width: "100%"}}>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}

                              autoHeight
                    />
                    <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                        <tfoot>
                        <Footer rows={rows}/>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default RefundReport;
